// -- CORE
import React from "react";
import { Redirect } from "react-router-dom";
// -- STATIC
import { Route } from "v2/api/classes/route";
import { MenuMode } from "v2/api/types/menuMode";
import { UserPermissions } from "v2/api/types/UserPermissions";
import {
  routes as moduleRoutes,
  defaultRoutes,
} from "@upptic/module-directory";
import { getCookie } from "react-use-cookie";
import { getInitalUrl } from "../routingHelper";

// -- PAGES

const Logout = React.lazy(() => import("screens/Auth/Logout/LogoutContainer"));
const SwitchClient = React.lazy(() =>
  import("screens/Auth/SwitchClientComponent"),
);

const AccessDenied = React.lazy(() => import("v2/pages/Auth/AccessDenied"));

const NoEntitlementsPage = React.lazy(() =>
  import("v2/pages/Auth/NoEntitlementsPage"),
);

const additionalRoutes = moduleRoutes.reduce<any>((acc, route, index) => {
  acc[index.toString()] = new Route<never>({
    path: route.path,
    component: route.component,
    exact: route.exact === undefined ? true : route.exact,
    menuMode: (route.menuMode as MenuMode) || MenuMode.APPLICATION_LISTING,
    permissions: route.permissions as UserPermissions[],
    layout: route.layout,
    supportsMobile: route.supportsMobile,
    formatTrackingInfo: route.formatTrackingInfo,
  });
  return acc;
}, {});

const moduleDefaultRoutes = defaultRoutes.reduce<any>((acc, route, index) => {
  acc[`default${index.toString()}`] = new Route<never>({
    path: route.path,
    component: route.component,
    exact: route.exact === undefined ? true : route.exact,
    menuMode: (route.menuMode as MenuMode) || MenuMode.APPLICATION_LISTING,
    permissions: route.permissions as UserPermissions[],
    layout: route.layout,
    formatTrackingInfo: route.formatTrackingInfo,
  });
  return acc;
}, {});

// -- ROUTES DEFINITION
export const authRoutes: Record<string, Route<any>> = {
  HOME: new Route<never>({
    path: "/",
    exact: true,
    render: ({ platformStore }: any) => {
      const locationBeforeLogout = getCookie("locationBeforeLogout");
      if (locationBeforeLogout) {
        document.cookie =
          "locationBeforeLogout=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        return <Redirect to={locationBeforeLogout} />;
      }
      return (
        <Redirect
          to={getInitalUrl(
            platformStore.modules,
            platformStore.currentClient?.code,
            platformStore.currentModule,
          )}
        />
      );
    },
    menuMode: MenuMode.APPLICATION_LISTING,
  }),
  ACCESS_DENIED: new Route<never>({
    path: "/access-denied",
    component: AccessDenied,
    exact: true,
    menuMode: MenuMode.APPLICATION_LISTING,
  }),
  NO_ENTITLEMENTS: new Route<never>({
    path: "/no-products",
    component: NoEntitlementsPage,
    exact: true,
    menuMode: MenuMode.APPLICATION_LISTING,
  }),
  ...additionalRoutes,
  ...moduleDefaultRoutes,

  LOGOUT: new Route<never>({
    path: "/logout",
    component: Logout,
    menuMode: MenuMode.APPLICATION_LISTING,
  }),

  SWITCH_CLIENT: new Route<never>({
    path: "/switchClient",
    component: SwitchClient,
    menuMode: MenuMode.APPLICATION_LISTING,
  }),

  PAGE_NOT_FOUND: new Route<never>({
    render: () => <Redirect to={"/"} />,
    menuMode: MenuMode.APPLICATION_LISTING,
  }),
};
